/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  OrganizationUserEmailSetting,
  OrganizationUserEmailSettingFromJSON,
  OrganizationUserEmailSettingFromJSONTyped,
  OrganizationUserEmailSettingToJSON
} from './OrganizationUserEmailSetting'
import { PageInfo, PageInfoFromJSON, PageInfoFromJSONTyped, PageInfoToJSON } from './PageInfo'

/**
 *
 * @export
 * @interface GetOrganizationUserEmailSettingsResponseData
 */
export interface GetOrganizationUserEmailSettingsResponseData {
  /**
   *
   * @type {Array<OrganizationUserEmailSetting>}
   * @memberof GetOrganizationUserEmailSettingsResponseData
   */
  organizationUserEmailSettings?: Array<OrganizationUserEmailSetting>
  /**
   *
   * @type {PageInfo}
   * @memberof GetOrganizationUserEmailSettingsResponseData
   */
  pageInfo?: PageInfo
}

export function GetOrganizationUserEmailSettingsResponseDataFromJSON(
  json: any
): GetOrganizationUserEmailSettingsResponseData {
  return GetOrganizationUserEmailSettingsResponseDataFromJSONTyped(json, false)
}

export function GetOrganizationUserEmailSettingsResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationUserEmailSettingsResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    organizationUserEmailSettings: !exists(json, 'organization_user_email_settings')
      ? undefined
      : (json['organization_user_email_settings'] as Array<any>).map(OrganizationUserEmailSettingFromJSON),
    pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
  }
}

export function GetOrganizationUserEmailSettingsResponseDataToJSON(
  value?: GetOrganizationUserEmailSettingsResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    organization_user_email_settings:
      value.organizationUserEmailSettings === undefined
        ? undefined
        : (value.organizationUserEmailSettings as Array<any>).map(OrganizationUserEmailSettingToJSON),
    page_info: PageInfoToJSON(value.pageInfo)
  }
}
